import { MicroappFbsReservationSlotModel } from './microapp-fbs-reservation-slot';

export class MicroappFbsResourceSlotModel{
    label:string;
    startDateTime: Date;
    endDateTime: Date;
    isReservable: boolean;
    isBooked: boolean;
    reservation: MicroappFbsReservationSlotModel;
}